<template>
  <div class="navbar__slider" :style="{'transform':'translate3d('+sliderOffset+'px,0,0)'}">
    <van-nav-bar
      title="单据重复提示"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
  
    <div class="info">
      <div class="tips">单据金额与以下已有记录重复，请检查</div>
      <div style="font-size: 12px; color: black">
        当单据船名、金额相差±10%、距离申请日期在一年内会出现此警告。
      </div>
    </div>
    <div class="infoPart">
      <div
        v-for="index in receiptData.data"
        :key="index"
      >
        <van-form ref="infoForm">
          <van-cell-group inset>
            <van-field
              class="labelStyle"
              :model-value="'#'+ index.id"
              name="receiptId"
              readonly
              label="单据ID"
            />
            <van-field
              class="labelStyle"
              :model-value="index.companyName"
              name="receiptId"
              readonly
              label="公司名称"
            />
            <van-field
              class="labelStyle"
              :model-value="index.customName"
              name="receiptId"
              readonly
              label="客户名称"
            />
            <van-field
              class="labelStyle"
              :model-value="index.shipName"
              name="receiptId"
              readonly
              label="船舶名称"
            />
            <van-field
              class="labelStyle"
              :model-value="index.gatheredTotal"
              name="receiptId"
              readonly
              label="总金额"
            />
            <van-field
              class="labelStyle"
              :model-value="index.applyAtDate"
              name="receiptId"
              readonly
              :label="this.findReceiptCostDataDes(index.receiptType)"
            />
            <van-field
              class="labelStyle"
              :model-value="index.submitAtDate"
              name="receiptId"
              readonly
              label="提交日期"
            />
          </van-cell-group>
        </van-form>
        <van-divider />
      </div>
    </div>
    <div style="margin: 0px;width:100%;margin-top: 10px;position: fixed; bottom: 10px;">
      <van-button
        class="normalBtn"
        type="danger"
        style="width:43%;margin-right:6%"
        @click="onClickLeft"
      >取消</van-button>
      <van-button
        class="normalBtn"
        type="success"
        style="width:43%;margin-right:0%"
        @click="this.$emit('submitForce')"
      >继续审核通过</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReceiptForce',
  mounted () {
    this.sliderOffset = -500
    setTimeout(() => {
      this.sliderOffset = 0
      
    }, 1000);
    // this.receiptData.data = this.receiptData.data.concat(this.receiptData.data)
  },
  methods: {
    onClickLeft: function () {
      this.sliderOffset = -500 // 屏幕垂直居中显示页面控制台中的位置，单位 vh 或;
      this.$emit('back')
    },
    findReceiptCostDataDes (receiptType) {
      console.log('findReceiptCostDes:', receiptType)
      if (receiptType == 1) {
        return '收款日期'
      } else if (receiptType == 2) {
        return '付款日期'
      } else {
        return '付款日期'
      }
    },
  },
  props: {
    receiptData: {
      type: Object,
      default: ()=>{}
    }
  },
  data () {
    return {
      sliderOffset: 0,
      rreceiptData_: { "data": [{ "applyAt": 1686822172775, "applyAtDate": "2023-06-15", "applyAtDesc": "2023-06-15 17:42:52", "attachFiles": "https://hans.pdmarket.cn/crmres/CHTRS 7TH SOA_1686822392569_7713.xlsx,https://hans.pdmarket.cn/crmres/7th hire bank slip_1686822398039_7167.pdf,https://hans.pdmarket.cn/crmres/7TH HIRE RECEIPT_1686822403835_3341.jpg,https://hans.pdmarket.cn/crmres/7TH HIRE_1686822419650_8990.pdf", "companyName": "MANDARINE OCEAN LTD", "currencyName": "USD", "customName": "LYNUX SHIPPING LIMITED", "flowUpdateAt": 1686881051828, "flowUpdateDate": "2023-06-16", "flowUpdateDesc": "2023-06-16 10:04:11", "flowUserIcon": "https://hans.pdmarket.cn/crmres/下载 (3)_1678116236302_4317.png", "flowUserId": 10, "flowUserLoginName": "Yss", "flowUserNickName": "姚双双", "gatheredTotal": 30898.08000000, "id": 1195, "isPay": 0, "isSelfClose": 0, "receiptRate": 1.00000000, "receiptType": 1, "refuseTimes": 0, "remarks": "2023/6/14-6/16租金", "shipName": "Christina ocean", "submitAt": 1686822424058, "submitAtDate": "2023-06-15", "submitAtDesc": "2023-06-15 17:47:04", "submitUserIcon": "https://hans.pdmarket.cn/crmres/下载 (10)_1678116009012_7656.png", "submitUserId": 6, "submitUserLoginName": "Alan", "submitUserNickName": "何颖", "submitUserRoleIds": [5, 4, 3], "verifyStatus": 6, "verifyStatusDesc": "出纳审核中", "voyagesName": "V23013" }], "errCode": 2013, "errMsg": "单据金额与以下已有记录重复，请检查", "isNeedParse": 1, "totalSize": 0 }

    }
  }
}
</script>

<style scoped>
.tips {
  color: red;
  font-size: 16px;
  padding-top: 10px;
}

.info{
  background-color:  rgb(250, 250, 250);
  padding-bottom: 15px;
}
.infoPart {
  background-color: rgb(236, 236, 236);
  padding: 15px;
  height: calc(100vh - 190px);
  padding-bottom: 60px;
  overflow: scroll;
}

/* 这个是切换的动画，采用css3来控制 */
.navbar__slider {
  position: absolute;
content: " ";
left: 0px;
top: 0px;
right: 0px;
bottom: 0;
z-index: 1001;
-webkit-transition: -webkit-transform .3s;
transition: -webkit-transform .3s;
transition: transform .3s;
transition: transform .3s, -webkit-transform .3s;
}
</style>